export const colorThresholds = {
  GREEN_PERCENT: 80,
  YELLOW_PERCENT: 50,
  MIN_PERCENT: 12,
}
